import { resetFavoritesState } from "@store/reducers/favorites";

import { ELocalStoreKeys } from "@/models/models";
import { logout } from "@/store/actions/user";
import { useAppDispatch, useAppDispatchUnwrap, useAppSelector } from "@/store/hooks";
import { resetUserState } from "@/store/reducers/user";
import { getMySelector, isAuthorized, loadingUser } from "@/store/selectors/getMeSelector";
import { getWithExpiry } from "@/utils/localStorage";

export const useAuth = () => {
  const isLoggedIn = useAppSelector(isAuthorized);
  const myData = useAppSelector(getMySelector);
  const isLoading = useAppSelector(loadingUser);

  return { isLoggedIn, myData, isLoading };
};

export const useLogOut = () => {
  const dispatch = useAppDispatchUnwrap();
  const syncDispatch = useAppDispatch();

  const accessToken = getWithExpiry(ELocalStoreKeys.TOKEN);
  const refreshToken = getWithExpiry(ELocalStoreKeys.REFRESH_TOKEN);
  const logoutUser = async () => {
    await dispatch(
      logout({
        refreshToken: refreshToken.value,
        accessToken: accessToken.value,
      }),
    );
  };
  const resetUser = () => {
    syncDispatch(resetUserState());
    syncDispatch(resetFavoritesState());
    // Clear per-session reminder dismissals so the next user (or the
    // same user logging back in) gets a fresh banner state. The
    // localStorage modal-closed flag is intentionally left alone — once
    // the user has seen the verify modal, they've seen it; re-logging
    // shouldn't force them to re-open + re-close it just to surface the
    // reminders again.
    try {
      sessionStorage.removeItem("pending-email-banner-dismissed");
    } catch { /* sessionStorage blocked — noop */ }
  };
  return { logoutUser, resetUser };
};
